const TRUTHY_VALUES = new Set(['1', 'true', 'yes', 'on']);

/**
 * Reads an opt-in env flag. Unset or unrecognized reads as disabled, so only an
 * explicit truthy value enables it. Use for `FLAG=on` style toggles; for default-on
 * flags check the disabling values instead.
 */
export function isEnvFlagEnabled(value: string | undefined): boolean {
	return value !== undefined && TRUTHY_VALUES.has(value.trim().toLowerCase());
}
